var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-switch',{attrs:{"active-color":_vm.openColor,"inactive-color":_vm.closeColor,"active-text":_vm.openText,"inactive-text":_vm.closeText,"disabled":_vm.disabledValue},on:{"change":_vm.change},model:{value:(_vm.fvalue),callback:function ($$v) {_vm.fvalue=$$v},expression:"fvalue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }